import { Options } from 'ky';
import config from 'config';
import { ShippingMethod, ShopSettings } from 'CoreApi.Settings_V12';
import { useAuthenticatedApiClient } from 'utils/apiClient/base';
import { SaveShippingMethodPayload, SettingsHeroImage } from 'Settings/types';
import { UploadingFile } from 'Common/types';
import { Product } from './types';

const clientOpts: Options = {
  prefixUrl: `${config.CORE_URL}/api`,
};

const headers = {
  'Content-type': 'application/json',
};

export default function useShopApi() {
  const authenticatedApiClient = useAuthenticatedApiClient().extend(clientOpts);

  return {
    getShopSettings: () =>
      authenticatedApiClient.get('shop/settings/').json<ShopSettings>(),

    postShopSettings: (payload: any) =>
      authenticatedApiClient
        .post('shop/settings/', {
          headers,
          body: JSON.stringify(payload),
        })
        .json(),
    getInstantToken: () =>
      authenticatedApiClient.post('auth/instant/generate/').json<string>(),

    setFeaturedProducts: (product: Product) => {
      const productCombined = [...product.added, ...product.deleted];
      return Promise.all(
        productCombined.map((id) =>
          authenticatedApiClient.post(`products/${id}/shop/`, {
            headers,
            body: JSON.stringify({ is_featured: product.added.includes(id) }),
          })
        )
      );
    },

    uploadShopImage: (data: SettingsHeroImage) => {
      const formData = new FormData();
      formData.append(data.image_type, data.file);
      return authenticatedApiClient.post('shop/settings/images/', {
        body: formData,
      });
    },

    getShippingMethods: () =>
      authenticatedApiClient
        .get('shop/service-costs/')
        .json<Array<ShippingMethod>>(),

    postShippingMethods: (data: Array<SaveShippingMethodPayload>) =>
      authenticatedApiClient
        .post('shop/service-costs/', {
          headers,
          body: JSON.stringify(data),
        })
        .json(),

    postCancelationRight: (data: { language: string; file: UploadingFile }) => {
      const formData = new FormData();
      formData.append('language', data.language.toLowerCase());
      formData.append('pdf', data.file);

      return authenticatedApiClient.post('shop/settings/cancellation_policy/', {
        body: formData,
      });
    },

    deleteCancelationRight: (language: string) =>
      authenticatedApiClient.delete('shop/settings/cancellation_policy/', {
        body: JSON.stringify(language),
        headers,
      }),
  };
}
